var aux = require("./__aux");
var gallery = require("./gallery.js");
var cookiesLib = require("./cookies");
var i18nLib = require("../i18n");
var moment = require("moment");
var Favorites = require("./favorite");

$(document).ready(function () {
	// Lazy loading for backend page renders
	aux.trySequentially({
		nTimes: 10, callback: function (success, failure) {
			setTimeout(function () {
				bLazy.revalidate();
				failure();
			}, 500);
		}
	});

	$('.tourListPart, #tourResult').on('click', '[data-load-more-url]', function (e) {
		var self = $(this).closest('.tourListPart, #tourResult');
		var toursLoadUrl = $("#toursList [data-load-more-url]").attr('data-load-more-url');
		bLazy.revalidate();
		e.preventDefault();
		$.ajax({
			url: toursLoadUrl,
			beforeSend: function () {
				$('#load-more-spinner').toggleClass("hidden");
				$("[data-load-more-url]").toggleClass("hidden");
			},
			success: function (data) {
				$('#load-more-spinner').toggleClass("hidden");
				$("[data-load-more-url]").toggleClass("hidden");
				var tourListCardsContainer = $("#toursList .theme-categories--cards")
				var $data = $(data);
				var newPageElements = $data.find("#toursList .theme-categories--cards");
				tourListCardsContainer.append(newPageElements.html());
				var lastPage = tourListCardsContainer.attr("data-tours-last-page");
				var newCurrentPage = newPageElements.attr("data-tours-current-page");
				var newPageUrl = newPageElements.attr("data-page-url");

				// push state to browser history if url changed
				newPageUrl = aux.clearUrlAnchor(newPageUrl).replace(/[&]*withFilters=true[&]*/g, '');
				if (aux.clearUrlAnchor(location.href) !== (location.host + newPageUrl)) {
					// Don't change URL for "my-booking" page
					if (!(
						location.search.indexOf('bookingId')
					)) {
						window.history.pushState(newPageUrl, document.title, newPageUrl);
					}
					// call analytics to register pageView
					if (typeof gtag === 'function') {
						var gaTrackingID = $('#gaTrackingID').val();
						if (gaTrackingID) {
							//gtag('config', gaTrackingID, { 'page_path': location.href });
						}
					}
				}
				if (parseInt(lastPage) == parseInt(newCurrentPage)) {
					$("[data-load-more-url]").remove();
				} else {
					var nextPageUrl = $data.find("[data-load-more-url]").attr("data-load-more-url");
					$("#toursList [data-load-more-url]").attr("data-load-more-url", nextPageUrl);
					toursLoadUrl = nextPageUrl;
				}

				tourListCardsContainer.attr("data-tours-current-page", newCurrentPage);
				tourListCardsContainer.attr("data-page-url", newPageUrl);

				// Global functions from js/authentic/exchangeCurrencies.js
				var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
				if (exchangeRateCurrency && tourListCardsContainer[0]) {
					window.switchExchangeRateCurrency(tourListCardsContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
				}

				bLazy.revalidate();
			}, cache: false
		}).then(function (data) {
			Favorites.favoriteTourList()
			self.trigger('loadMoreFinished', { response: data });
		});

		aux.trySequentially({
			nTimes: 20, callback: function (success, failure) {
				setTimeout(function () {
					bLazy.revalidate();
					failure();
				}, 500);
			}
		});
	});

	$('[data-modal-static-url]').each(function () {
		var modalStaticHolder = $(this);
		$.ajax({
			url: modalStaticHolder.attr('data-modal-static-url'),
			cache: true,
			headers: {
				'Cache-Control': 'public,immutable'
			},
			type: "GET",
			dataType: 'html'
		}).then(function (data) {
			Favorites.favoriteTourList()
			modalStaticHolder.html(data);
		});
	});

	$(document.body).on('hidden.bs.modal', function (e) {
		$('#experienceModal').removeData('bs.modal');
		$('#experienceModal .modal-content').html("");
	});

	$('#experienceModal').on('show.bs.modal', function (event) {
		var anchor = $(event.relatedTarget);
		var componentUrl = anchor.attr('data-experience-component-url');
		if (typeof componentUrl === 'string') {
			var modal = $(this);
			$.ajax({
				url: componentUrl,
				type: "GET",
				dataType: 'html'
			}).then(function (data) {
				var template = $('#modalStaticHolder').html();
				modal.find('.modal-content').html(template);
				modal.find('.dynamicContentHolder').html(data);
			}, function (e) {
				console.error(e);
				$('#experienceModal').modal('hide');
			});
		}
	});

	if ($("#loadTourExperiencesUrl").length) {
		$.ajax({
			url: $("#loadTourExperiencesUrl").val(),
			headers: {
				'Cache-Control': 'no-cache,no-store,must-revalidate'
			},
			success: function (data) {
				var dataEl = $('<span>' + data + '</span>')

				$("[data-role='experiences-block']").each(function () {
					$(this).html(dataEl.find("#" + $(this).attr("id")).html());
				})

				$("#tourGallery").html(dataEl.find("#tourGallery").html());
				gallery.runGallery();

				var itineraryAccordionContainer = $('.accordion--group')

				// Global functions from js/authentic/exchangeCurrencies.js
				var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
				if (exchangeRateCurrency && itineraryAccordionContainer[0]) {
					window.switchExchangeRateCurrency(itineraryAccordionContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
				}
			}
		}).then(function (data) {
			Favorites.favoriteTourList()
		});
	}

	$(".tour-location:visible").select2({
		placeholder: i18nLib.localize("Select location")
	});

	$(".tour-hotel-category").select2({
		placeholder: i18nLib.localize("Select hotel category")
	});

	$("#tourAnyQuestion, #tourAnyQuestionDescription, a.cta-block__button--request-quote").on("click", function (e) {
		e.preventDefault();

		var $target = $(this);
		var destination = $("#tourQuestionPage").val() || $target.attr("data-request-quote-ref") || $target.attr("href");

		cookiesLib.setCookie("tour_question_tourId", $("#tourId").val() || "");
		cookiesLib.setCookie("tour_question_tourLocationId", $("#startLocationId").val() || "");
		cookiesLib.setCookie("tour_question_tourUrl", window.location.href);

		if (destination && destination !== "#") {
			window.location.href = destination;
		}
	});

	$("a.cta-block__button--ai-chat").click(function (event) {
		event.preventDefault();

		var chat = document.getElementById("ai-chat");
		var shadowRoot = chat && chat.shadowRoot;
		var openButton = shadowRoot && shadowRoot.querySelector('button[aria-label="Open chat"]');

		if (openButton) {
			openButton.click();
		}
	});

	$(".questionPageReturnTour").click(function (eventButton) {
		eventButton.preventDefault();
		cookiesLib.setCookie("tour_question_tourId", "");
		cookiesLib.setCookie("tour_question_tourLocationId", "");
		cookiesLib.setCookie("tour_question_tourUrl", "");
		window.location.href = $("#previousPage").val();
	});

	function getErrorObj (errorName, dataText) {
		var textError = $("#tourQuestionError" + errorName).data(dataText);
		return {
			errorContainer: "#tourQuestionError" + errorName,
			errorFocus: ".booking--details--inputs",
			errorText: textError
		}
	}

	function validateEmail (email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	$('#tourQuestionForm').validator();
	$('#tourQuestionForm input, #tourQuestionForm textarea').bind('keyup change', function () {
		if (!$(this).parents("div.form-group").eq(0).hasClass("has-error") || $(this).val() != "") {
			$(this).parents("div.form-group").eq(0).find(".help-block.with-errors").hide();
			$(this).parents("div.form-group").eq(0).find(".has-error").removeClass("has-error");
			$(this).parents("div.form-group").removeClass("has-error");
		}
	});

	$("#tourQuestionForm").on("submit", function (e) {
		e.preventDefault();
		var errors = [];

		if (!$("#input--name").val()) {
			errors.push(getErrorObj("Name", "error-text"));
		}
		if (!$("#input--email").val()) {
			errors.push(getErrorObj("Email", "error-text"));
		}
		if ($("#input--email").val() && !validateEmail($("#input--email").val())) {
			errors.push(getErrorObj("Email", "error-text-secondoption"));
		}
		if (!$("#howCanWeHelp-text").val()) {
			errors.push(getErrorObj("Text", "error-text"));
		}
		if (errors.length > 0) {
			errors.forEach(function (error) {
				if (!$(error.errorContainer).parent().hasClass("has-error")) {
					$(error.errorContainer).parent().addClass("has-error");
				}
				$(error.errorContainer).show();
				$(error.errorContainer).html(error.errorText);
			});

			$('body, html').animate({
				scrollTop: parseInt($(errors[0].errorFocus).offset().top)
			}, 800, function () {
				window.location.hash = errors[0].errorFocus;
			});
		}

		var elements = Array.prototype.slice.call($(this)[0].elements);
		var jsonFields = elements.reduce((result, element) => {
			const field = $(element);
			const name = field.attr('name');
			const val = field.val();
			if (name) {
				result[name] = val;
			}
			return result;
		}, {});

		if (errors.length == 0) {
			// Handling field values
			for (let [name, val] of Object.entries(jsonFields)) {
				switch (name) {
					case 'travelDate':
						const div = ' - ';
						const travelDateRaw = val ? String(val).trim() : '';
						if (!travelDateRaw) {
							jsonFields[name] = '';
							break;
						}
						if (travelDateRaw.indexOf(div) !== -1) {
							const travelDateParts = travelDateRaw.split(div);
							const startDate = moment(travelDateParts[0].trim(), "DD. MMMM YY").format("YYYY-MM-DD");
							const endPart = (travelDateParts[1] || '').trim();
							if (endPart) {
								const endDate = moment(endPart, "DD. MMMM YY").format("YYYY-MM-DD");
								if (endDate !== startDate) {
									jsonFields[name] = [startDate, endDate].join(div);
									break;
								}
							}
							jsonFields[name] = startDate;
						} else {
							const startDate = moment(travelDateRaw, "DD. MMMM YY").format("YYYY-MM-DD");
							jsonFields[name] = startDate;
						}
						break;
				}
			}

			$("#global-overlay").removeClass("hidden");
			$("#global-spinner").removeClass("hidden");

			$.ajax({
				url: $("#tourQuestionService").val(),
				method: 'POST',
				dataType: 'json',
				data: {
					data: JSON.stringify(jsonFields)
				},
				success: function (data) {
					$("#global-overlay").addClass("hidden");
					$("#global-spinner").addClass("hidden");
					if (data.success) {
						cookiesLib.setCookie("tour_question_tourId", "");
						cookiesLib.setCookie("tour_question_tourLocationId", "");
						cookiesLib.setCookie("tour_question_tourUrl", "");
						$(".hideField").addClass("hidden");
						$(".showField").removeClass("hidden");
					}
				}
			})
		}
	});

	$(".travelers--input-question-tour [data-ride=spinner]").on("change", function (spinnerEvent) {
		var mainInput = $("#travelers").val();
		var travelers = [];

		setTravelersInputTourQuestion("#spinner1", travelers, " " + i18nLib.localize("adults"), " " + i18nLib.localize("adult"))

		setTravelersInputTourQuestion("#spinner2", travelers, " " + i18nLib.localize("children"), " " + i18nLib.localize("child"))

		setTravelersInputTourQuestion("#spinner3", travelers, " " + i18nLib.localize("infants"), " " + i18nLib.localize("infant"))

		$("#travelers").val(travelers.join(", "));
	});

	function setTravelersInputTourQuestion (target, travelers, pluralLabel, singleLabel) {
		if ($(target).val() && $(target).val() != "0") {
			var valuesText = $(target).val();

			if ($(target).val() > 1)
				valuesText += pluralLabel;
			else
				valuesText += singleLabel;

			travelers.push(valuesText);
		}
	}
});



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/tours.js